define("shared/components/shared/post/secondary/activity/comment", ["exports", "@ember/component", "@ember/string", "@glimmer/component", "lodash", "later/utils/is-emoji-only", "@ember/template-factory"], function (_exports, _component, _string, _component2, _lodash, _isEmojiOnly, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/string",0,"@glimmer/component",0,"lodash",0,"later/utils/is-emoji-only",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <li class={{concat-classes "cAP--list__item qa--activity_modal_commentItem" (if @comment.isNew "is--new")}}>
    <div class={{concat-classes "cAP--userInitial" (if @comment.isExternal "cAP--userInitial__external")}}>
      <span>{{this.usernameInitial}}</span>
    </div>
    <div class="cAP--comment">
      <div class="cAP--comment__header u--ellipsis">
        <span class="cAP--comment__userName u--ellipsis">
          {{@comment.username}}
          {{#if @comment.isExternal}}
            <span class="u--text--base u--text--lowercase">
              ({{t "shared_words.external"}})
            </span>
          {{/if}}
        </span>
        <span class="cAP--comment__timestamp">
          {{@comment.timestamp}}
        </span>
      </div>
      <span class={{concat-classes (if this.showLargeText "u--text--lg")}}>
        {{html-safe this.formattedComment}}
      </span>
    </div>
  </li>
  */
  {
    "id": "P6vSqCVi",
    "block": "[[[10,\"li\"],[15,0,[28,[37,0],[\"cAP--list__item qa--activity_modal_commentItem\",[52,[30,1,[\"isNew\"]],\"is--new\"]],null]],[12],[1,\"\\n  \"],[10,0],[15,0,[28,[37,0],[\"cAP--userInitial\",[52,[30,1,[\"isExternal\"]],\"cAP--userInitial__external\"]],null]],[12],[1,\"\\n    \"],[10,1],[12],[1,[30,0,[\"usernameInitial\"]]],[13],[1,\"\\n  \"],[13],[1,\"\\n  \"],[10,0],[14,0,\"cAP--comment\"],[12],[1,\"\\n    \"],[10,0],[14,0,\"cAP--comment__header u--ellipsis\"],[12],[1,\"\\n      \"],[10,1],[14,0,\"cAP--comment__userName u--ellipsis\"],[12],[1,\"\\n        \"],[1,[30,1,[\"username\"]]],[1,\"\\n\"],[41,[30,1,[\"isExternal\"]],[[[1,\"          \"],[10,1],[14,0,\"u--text--base u--text--lowercase\"],[12],[1,\"\\n            (\"],[1,[28,[35,2],[\"shared_words.external\"],null]],[1,\")\\n          \"],[13],[1,\"\\n\"]],[]],null],[1,\"      \"],[13],[1,\"\\n      \"],[10,1],[14,0,\"cAP--comment__timestamp\"],[12],[1,\"\\n        \"],[1,[30,1,[\"timestamp\"]]],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n    \"],[10,1],[15,0,[28,[37,0],[[52,[30,0,[\"showLargeText\"]],\"u--text--lg\"]],null]],[12],[1,\"\\n      \"],[1,[28,[35,3],[[30,0,[\"formattedComment\"]]],null]],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[13]],[\"@comment\"],false,[\"concat-classes\",\"if\",\"t\",\"html-safe\"]]",
    "moduleName": "shared/components/shared/post/secondary/activity/comment.hbs",
    "isStrictMode": false
  });
  class CommentComponent extends _component2.default {
    get usernameInitial() {
      return (0, _string.capitalize)(this.args.comment.username[0]);
    }
    get showLargeText() {
      return (0, _lodash.toArray)(this.args.comment.content).length <= 3 && (0, _isEmojiOnly.default)(this.args.comment.content);
    }
    get formattedComment() {
      return this.args.comment.content.replace(/\n/g, '<br>');
    }
  }
  _exports.default = CommentComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, CommentComponent);
});